<div class="row mx-0">
  <div class="col-12 col-lg-6 bg-white login-content-left d-flex justify-content-center align-items-center"
       style="min-height: 100vh; padding-bottom: 75px;">

    <div class="content-login">
      <!-- <img src="{% static 'img/eficacia-brand.png' %}" alt="eficacia" class="ig-fluid mb-5"> -->
      <h1 class="font-size-20 font-solomon">{{ 'Hola,' | translate }}</h1>
      <h1 class="font-size-20 font-solomon mb-4">{{ 'Te damos la bienvenida' | translate }}</h1>
      <h2 class="font-size-20 font-solomon-bold mb-4">{{ 'Ingresar' | translate }}</h2>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <app-alert></app-alert>
        <div class="form-group">
          <label for="email">{{ 'Correo electrónico' | translate }} *</label>
          <input type="email" formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                 class="form-control" id="email" placeholder="{{ 'Escribe tu correo electrónico' | translate }}" aria-describedby="email">
        </div>
        <div class="form-group mb-0">
          <label for="exampleInputPassword1">{{ 'Contraseña' | translate }} *</label>
          <input  type="password" autocomplete="off" placeholder="{{ 'Inserta tu contraseña' | translate }}" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" class="form-control" id="exampleInputPassword1">
        </div>

        <div class="row mx-0">
          <div class="col-12 col-lg-5 pl-0">
            <div class="form-group form-check squaredThree">
              <input type="checkbox" class="form-check-input" id="squaredThree" checked>
              <label class="form-check-label" for="squaredThree"><span
                style="margin-left: 30px;">{{ 'Recordarme' | translate }}</span></label>
            </div>
          </div>
          
          <div class="col-12 col-lg-7 px-0 d-flex justify-content-end">
            <a href="#" class="my-3 link-black-404040 font-size-16" [routerLink]="['/forget-password']">{{ '¿Olvidaste tu contraseña?' | translate }}</a>
          </div>
        </div>


        <button type="submit" class="btn btn-primary btn-blue-dark-rounded mb-3" [disabled]="loading || form.invalid" > <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> {{ 'Ingresar a la plataforma' | translate }}</button>

        

        <div class="p-4 w-52 h-24 justify-content-center align-items-center d-flex flex-column mb-3">
            <a href="#" class="my-0 mx-0 link-0041a3 font-size-16"  style="color: #0041a3;" [routerLink]="['/terms-conditions']">{{ 'Términos y condiciones' | translate }}</a>
            <a href="#" class="my-0 link-0041a3 font-size-16"  style="color: #0041a3;" [routerLink]="['/privacy-policy']">{{ 'Política de privacidad' | translate }}</a>
        </div>

      </form>

    </div>

  </div>
  <div class="col-12 col-lg-6 d-flex justify-content-start align-items-end p-3 p-lg-5"
       style="/*background: url('assets/img/bg-login.png');*/ background-color: #0041A3; background-size: cover; padding-bottom: 75px!important;">
    <h2 class="font-size-50 font-solomon text-white m-0 m-lg-5" style="max-width: 530px;">{{ 'Un ecosistema para la transformación digital de los clientes del futuro, hoy.' | translate }}</h2>
  </div>
  <app-footer></app-footer>
</div>
